module.exports = __webpack_public_path__ + "static/media/focused_working.4d99a243.svg";